<script setup lang="ts">
/* eslint-disable max-len */
interface IconStatsProps {
  fill?: string;
}
const props = withDefaults(defineProps<IconStatsProps>(), {
  fill: "#E8332B",
});
</script>

<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.333 1.333a.667.667 0 1 1 0-1.333h4A.667.667 0 0 1 12 .667v4a.667.667 0 1 1-1.333 0v-2.39L4.47 8.47a.667.667 0 0 1-.942-.942l6.195-6.196h-2.39zM0 2.667c0-.737.597-1.334 1.333-1.334h3.334a.667.667 0 1 1 0 1.334H1.333v8h8V7.333a.667.667 0 1 1 1.334 0v3.334c0 .736-.597 1.333-1.334 1.333h-8A1.333 1.333 0 0 1 0 10.667v-8z"
      :fill="props.fill"
      fill-rule="evenodd"
    />
  </svg>
</template>
